import React, { useContext } from 'react';
import { Placeholder as ReactPlaceholder, } from '@sitecore-jss/sitecore-jss-react';
import { ComponentPropsReactContext } from './ComponentPropsContext';
export const Placeholder = (props) => {
    const componentPropsContext = useContext(ComponentPropsReactContext);
    return (React.createElement(ReactPlaceholder, Object.assign({}, props, { modifyComponentProps: (initialProps) => {
            if (!initialProps.rendering.uid)
                return initialProps;
            const data = componentPropsContext[initialProps.rendering.uid];
            return Object.assign(Object.assign({}, initialProps), data);
        } })));
};
